import { render, staticRenderFns } from "./inveChilddetail.vue?vue&type=template&id=b1cce654&scoped=true"
import script from "./inveChilddetail.vue?vue&type=script&lang=js"
export * from "./inveChilddetail.vue?vue&type=script&lang=js"
import style0 from "./inveChilddetail.vue?vue&type=style&index=0&id=b1cce654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cce654",
  null
  
)

export default component.exports